<template>
  <div class="area-back">
    <i class="el-icon-back" @click="pageBack"></i>
    <span @click="pageBack">{{backName}}</span>
  </div>
</template>

<script>
export default {
  props: {
    backName: {
      type: String,
      default: '返回'
    },
    closeName: {
      type: String,
      default: ''
    }
  },
  methods: {
    pageBack() {
      if (this.closeName) {
        this.updateTabs()
      }
      // this.$router.go(-1)
      this.$router.back()
    },
    updateTabs() {
      // 删除当前路由
      let tagsList = sessionStorage.getItem('route') ? JSON.parse(sessionStorage.getItem('route')) : []
      let routeIndex = tagsList.findIndex(item => item.name === this.closeName)
      if (routeIndex > -1) {
        tagsList.splice(routeIndex, 1)
        this.$store.dispatch('setRouteTab', tagsList)
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
